module.exports = __webpack_public_path__ + "img/3d3eb71.jpg";